import React from 'react';
import { connect } from 'react-redux';
import { faFolderOpen } from '@fortawesome/free-regular-svg-icons';
import { faPaste } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ReportCenter.module.css'

class ReportCenter extends React.Component {
    render() {
        return (
            <div className={styles.outer_wrapper}>
                {Object.keys(this.props.parents)
                    .map(id => {
                        const parent = this.props.parents[id];
                        return (
                            <div key={parent.MRNO} className={styles.wrapper}>
                                <a href={parent.MRURL} className={styles.parent_row} target='_blank' rel="noopener noreferrer">
                                    <span className={styles.icon_wrapper}>
                                        <FontAwesomeIcon icon={faFolderOpen} />
                                    </span>
                                    <span className={styles.link}>{parent.MRNAME}</span>
                                </a>
                                {Object.keys(this.props.children)
                                    .filter(x => this.props.children[x].MRPARENT === parent.MRNO)
                                    .sort((a, b) => this.props.children[a].MRORDER - this.props.children[b].MRORDER)
                                    .map(x => {
                                        const child = this.props.children[x];
                                        return (
                                            <a key={child.MRNO} href={child.MRURL} className={styles.child_row} target='_blank' rel="noopener noreferrer">
                                                <span className={styles.icon_wrapper}>
                                                    <FontAwesomeIcon icon={faPaste} />
                                                </span>
                                                <span className={styles.link}>{child.MRNAME}</span>
                                            </a>
                                        )
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div >
        );
    }
}

function mapStateToProps(state) {
    let cmAccess = state.entities.authentication.user.cmAccess;

    let parents = state.entities.masterData.PTMASTERREPORTS ? Object.keys(state.entities.masterData.PTMASTERREPORTS)
        .filter(x => state.entities.masterData.PTMASTERREPORTS[x].MRPARENT === null &&
            (state.entities.masterData.PTMASTERREPORTS[x].MRMANAGER === false ||
                (state.entities.masterData.PTMASTERREPORTS[x].MRMANAGER === true && cmAccess === true)))
        .sort((a, b) => state.entities.masterData.PTMASTERREPORTS[a].MRORDER - state.entities.masterData.PTMASTERREPORTS[b].MRORDER)
        .map(x => state.entities.masterData.PTMASTERREPORTS[x]) : {};

    let children = state.entities.masterData.PTMASTERREPORTS ? Object.keys(state.entities.masterData.PTMASTERREPORTS)
        .filter(x => state.entities.masterData.PTMASTERREPORTS[x].MRPARENT !== null &&
            (state.entities.masterData.PTMASTERREPORTS[x].MRMANAGER === false ||
                (state.entities.masterData.PTMASTERREPORTS[x].MRMANAGER === true && cmAccess === true)))
        .sort((a, b) => state.entities.masterData.PTMASTERREPORTS[a].MRORDER - state.entities.masterData.PTMASTERREPORTS[b].MRORDER)
        .map(x => state.entities.masterData.PTMASTERREPORTS[x]) : {};

    return {
        parents,
        children
    };
}

const connectedReportCenter = connect(mapStateToProps)(ReportCenter);
export { connectedReportCenter as ReportCenter };
